
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFanStatic as ObiFanStaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-fan-static.js';
 
 
 

 
 export const ObiFanStatic = createComponent({
   react: React,
   tagName: 'obi-fan-static',
   elementClass: ObiFanStaticElement,
   events: {
     
   }
  });
 
 